import {
  FETCH_KITCHEN_ORDERS,
  FETCH_KITCHEN_ORDERS_SUCCESS,
  FETCH_KITCHEN_ORDERS_FAILURE,
  MARK_KITCHEN_ORDER_SERVED,
  MARK_KITCHEN_ORDER_SERVED_SUCCESS,
  MARK_KITCHEN_ORDER_SERVED_FAILURE,
} from "./constants";

export const fetchKitchenOrders = (payload) => ({
  type: FETCH_KITCHEN_ORDERS,
  payload,
});
export const fetchKitchenOrdersSuccess = (payload) => ({
  type: FETCH_KITCHEN_ORDERS_SUCCESS,
  payload,
});
export const fetchKitchenOrdersFailure = () => ({
  type: FETCH_KITCHEN_ORDERS_FAILURE,
});

export const markKitchenOrderServed = (payload) => ({
  type: MARK_KITCHEN_ORDER_SERVED,
  payload,
});
export const markKitchenOrderServedSuccess = () => ({
  type: MARK_KITCHEN_ORDER_SERVED_SUCCESS,
});
export const markKitchenOrderServedFailure = () => ({
  type: MARK_KITCHEN_ORDER_SERVED_FAILURE,
});
